<ng-container *transloco="let t">
  <div id="error-overlay" class="options-dialog popsy-card" [class.rtl]="rtlMode">
    <section class="dialog-header">
      <button
        type="button"
        mat-button
        class="close-button"
        (click)="dismiss()"
        tabindex="-1">
        <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
      </button>
    </section>
    <div class="content">
      @if (isStcPayErrorCode) {
        <div class="illustration">
          <popsy-lottie-animation
            class="lottie-animation"
            animation="delivery-card-declined"></popsy-lottie-animation>
        </div>
        <span class="fixed-space-24" aria-hidden="true"></span>
      }
      <h3>{{ t(errorTitle) || errorTitle }}</h3>
      <span>{{ t(errorMessage) || errorMessage }}</span>
    </div>
    <span class="fixed-space-24" aria-hidden="true"></span>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <div class="actions">
      @if (showReportButton) {
        <button
          class="button popsy-button-secondary"
          [attr.aria-label]="t('action_help')"
          (click)="toggleReportDialog()">
          {{ t('action_help') }}
        </button>
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      <button
        class="button popsy-button-primary"
        [attr.aria-label]="t('report_dialog_dismiss_button')"
        (click)="dismiss()">
        {{ t('report_dialog_dismiss_button') }}
      </button>
    </div>

    <span class="fixed-space-16" aria-hidden="true"></span>
  </div>
</ng-container>
